import React, { useContext } from 'react'
import UserContext from '@context/UserContext'
import UseWindowSize from '@components/helpers/UseWindowSize'
import SoftButton from '@components/common/SoftButton'
import { ArrowRight } from '@phosphor-icons/react'

// assets
import banner from '@images/BeachClub/landing-page/bbbc-landing-banner.webp'
import bannerTablet from '@images/BeachClub/landing-page/bbbc-landing-banner-tablet.webp'
import bannerMobile from '@images/BeachClub/landing-page/bbbc-landing-banner-mobile.webp'

const LandingPageBanner = ({handleLoginModal}) => {
	const { width } = UseWindowSize()
	const { isLoggedIn, toggleAccountMenu } = useContext(UserContext)

	return (
		<React.Fragment>
			<div className='relative landing-page-banner'>
				{(width && width < 640) ? (<>
					<img src={bannerMobile} alt='Join to get rewards and exclusive club benefits as you shop.' />
				</>) : (width && width < 768) ? (<>
					<img src={bannerTablet} alt='Join to get rewards and exclusive club benefits as you shop.' />
				</>) : (<>
					<img src={banner} alt='Join to get rewards and exclusive club benefits as you shop.' />
				</>)}
				<div className='size-0.5'></div>

				<div className='absolute w-full m-auto bottom-0 z-[2]'>
					<SoftButton
						className={'btn-primary !bg-[#FF9848] w-[197px] justify-center mx-auto mb-28 md:mb-20 lg:mb-28 xl:mb-40'}
						icon={<ArrowRight size={20} weight='light' />}
						ariaLabel={isLoggedIn ? 'Go to My Account' : 'Join Now'}
						label={isLoggedIn ? 'Go to My Account' : 'Join Now'}
						onClick={() => {
							if(isLoggedIn) toggleAccountMenu()
							else handleLoginModal(true)
						}}
					/>
				</div>
			</div>
		</React.Fragment>
	)
}

export default LandingPageBanner